<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Convênio de cobrança com o banco."
    [(visible)]="showDialog"
    [header]="convenio() ? 'Editar Convênio' : 'Novo Convênio'"
    [breakpoints]="{ '1200px': '85vw', '768px': '95vw' }"
    [style]="{ width: '980px' }"
    (onShow)="onDialogShow()"
>
    <form [formGroup]="convenioForm" (ngSubmit)="salvar()" class="flex flex-col gap-4 pt-2">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex flex-col gap-2">
                <label for="convenio" class="font-medium">Convênio <span class="text-red-500">*</span></label>
                <input pInputText id="convenio" formControlName="convenio" [class.ng-invalid]="isInvalid('convenio')" [class.ng-dirty]="isInvalid('convenio')" />
                @if (isInvalid('convenio')) {
                    <p-message severity="error" variant="simple">Convênio é obrigatório</p-message>
                }
            </div>

            <div class="flex flex-col gap-2">
                <label for="tipoGeracao" class="font-medium">Tipo de Geração <span class="text-red-500">*</span></label>
                <input pInputText id="tipoGeracao" formControlName="tipoGeracao" [class.ng-invalid]="isInvalid('tipoGeracao')" [class.ng-dirty]="isInvalid('tipoGeracao')" />
                @if (isInvalid('tipoGeracao')) {
                    <p-message severity="error" variant="simple">Tipo de Geração é obrigatório</p-message>
                }
            </div>

            <div class="flex flex-col gap-2">
                <label for="numeroCarteira" class="font-medium">Nº Carteira <span class="text-red-500">*</span></label>
                <input pInputText id="numeroCarteira" formControlName="numeroCarteira" [class.ng-invalid]="isInvalid('numeroCarteira')" [class.ng-dirty]="isInvalid('numeroCarteira')" />
                @if (isInvalid('numeroCarteira')) {
                    <p-message severity="error" variant="simple">Nº Carteira é obrigatório</p-message>
                }
            </div>

            <div class="flex flex-col gap-2">
                <label for="variacao" class="font-medium">Variação</label>
                <input pInputText id="variacao" formControlName="variacao" />
            </div>

            <div class="flex flex-col gap-2">
                <label for="codigoCedente" class="font-medium">Código do Cedente <span class="text-red-500">*</span></label>
                <input pInputText id="codigoCedente" formControlName="codigoCedente" [class.ng-invalid]="isInvalid('codigoCedente')" [class.ng-dirty]="isInvalid('codigoCedente')" />
                @if (isInvalid('codigoCedente')) {
                    <p-message severity="error" variant="simple">Código do Cedente é obrigatório</p-message>
                }
            </div>

            <div class="flex items-center gap-3 pt-7">
                <p-toggleswitch formControlName="compartilhado" inputId="compartilhado"></p-toggleswitch>
                <label for="compartilhado" class="font-medium cursor-pointer">Compartilhado</label>
            </div>

            <div class="flex flex-col gap-2">
                <label for="tipoConvenio" class="font-medium">Tipo Convênio <span class="text-red-500">*</span></label>
                <p-select
                    [appendTo]="'body'"
                    id="tipoConvenio"
                    formControlName="tipoConvenio"
                    [options]="tiposConvenio()"
                    optionLabel="sigla"
                    optionValue="coTipoConvenio"
                    placeholder="Selecione o tipo"
                    [class.ng-invalid]="isInvalid('tipoConvenio')"
                    fluid
                ></p-select>
                @if (isInvalid('tipoConvenio')) {
                    <p-message severity="error" variant="simple">Tipo Convênio é obrigatório</p-message>
                }
            </div>

            <div class="flex flex-col gap-2">
                <label for="tipoConvenioRemessa" class="font-medium">Tipo Convênio Remessa <span class="text-red-500">*</span></label>
                <input pInputText id="tipoConvenioRemessa" formControlName="tipoConvenioRemessa" [class.ng-invalid]="isInvalid('tipoConvenioRemessa')" [class.ng-dirty]="isInvalid('tipoConvenioRemessa')" />
                @if (isInvalid('tipoConvenioRemessa')) {
                    <p-message severity="error" variant="simple">Tipo Convênio Remessa é obrigatório</p-message>
                }
            </div>

            <div class="flex flex-col gap-2">
                <label for="status" class="font-medium">Status <span class="text-red-500">*</span></label>
                <input pInputText id="status" formControlName="status" [class.ng-invalid]="isInvalid('status')" [class.ng-dirty]="isInvalid('status')" />
                @if (isInvalid('status')) {
                    <p-message severity="error" variant="simple">Status é obrigatório</p-message>
                }
            </div>

            <div class="flex items-center gap-3 pt-7">
                <p-toggleswitch formControlName="registrado" inputId="registrado"></p-toggleswitch>
                <label for="registrado" class="font-medium cursor-pointer">Registrado</label>
            </div>

            <div class="flex flex-col gap-2">
                <label for="permanenciaBoleto" class="font-medium">Permanência do Boleto</label>
                <input pInputText id="permanenciaBoleto" formControlName="permanenciaBoleto" />
            </div>

            <div class="flex flex-col gap-2">
                <label for="apelido" class="font-medium">Apelido</label>
                <input pInputText id="apelido" formControlName="apelido" />
            </div>

            <div class="flex flex-col gap-2">
                <label for="codigoCedenteCfm" class="font-medium">Código do Cedente CFM</label>
                <input pInputText id="codigoCedenteCfm" formControlName="codigoCedenteCfm" />
            </div>

            <div class="flex flex-col gap-2">
                <label for="numeroAgenciaCfm" class="font-medium">Nº Agência CFM</label>
                <input pInputText id="numeroAgenciaCfm" formControlName="numeroAgenciaCfm" />
            </div>

            <div class="flex flex-col gap-2">
                <label for="percentualRateioCfm" class="font-medium">% Rateio CFM</label>
                <input pInputText id="percentualRateioCfm" formControlName="percentualRateioCfm" />
            </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (click)="hideDialog()" />
            <p-button label="Salvar" icon="pi pi-check" type="submit" [appCan]="roleBancosEditar" />
        </div>
    </form>
</p-dialog>
